<template>
  <div class="myWarehouseList">
    <div class="select">
      <table style="font-size: 16px">
        <tr>
          <td>
            仓库名称:
            <el-input v-model="warehouseName"></el-input>
            设备类型:
            <el-select v-model="deviceType" placeholder="请选择">
              <el-option
                v-for="item in deviceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td>
            <el-button style="background-color: #FF9000; color: #FFFFFF;" icon="el-icon-search">搜索</el-button>
            <el-button type="info" class="el-icon-delete">清空</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data">
      <el-button style="background-color: #FF9000; color: #FFFFFF; float: left; margin-bottom: 10px" icon="el-icon-plus"
                 @click="dialogVisible = true">新增入库
      </el-button>
      <el-table
        :data="deviceList"
        border
        style="width: 100%">
        <el-table-column
          prop="deviceCode"
          label="设备编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="warehouseName"
          label="仓库名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="deviceType"
          label="设备类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="supplier"
          label="设备供应商"
          align="center">
        </el-table-column>
        <el-table-column
          prop="inTime"
          label="入库时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="goods"
          label="是否良品"
          align="center">
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作"
          align="center">
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="100"
          layout="total, prev, pager, next, jumper"
          :total="400">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="入库"
      align="left"
      :visible.sync="dialogVisible"
      width="50%">
      <div class="dialog" style="width:100%; height: 250px;">
        <table style="width:100%; text-align: left">
          <tr>
            <td><span style="color: red">*</span><span>入库仓库：</span>
              <el-select v-model="value" clearable placeholder="入库仓库" style="width: 77%">
                <el-option
                  v-for="item in inWarehouseOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
            <td><span>设备类型：</span>
              <el-select v-model="value" clearable placeholder="设备类型" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr style="height: 70px">
            <td><span style="color: red">*</span><span>设备供应商：</span>
              <el-select v-model="value" clearable placeholder="设备供应商" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
            <td><span style="color: red">*</span><span>入库方式：</span>
              <el-select v-model="value" clearable placeholder="入库方式" style="width: 77%">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td><span style="color: red">*</span><span>入库文件</span>
              <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                :on-exceed="handleExceed"
                :file-list="fileList">
                <el-button size="small" icon="el-icon-upload" style="background-color: #FF9000; color: #FFFFFF">入库文件
                </el-button>
              </el-upload>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #FF9000" @click="dialogFormVisible = false">确 定</el-button>
        <el-button @click="dialogFormVisible = false" type="info">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MyWarehouseList',
  data() {
    return {
      deviceTypeOptions: [{
        value: '1',
        label: '6口设备'
      },
        {
          value: '2',
          label: '9口设备'
        },
        {
          value: '3',
          label: '12口设备'
        },
        {
          value: '4',
          label: '36口设备'
        }],
      deviceType: '',
      deviceList: [{
        deviceCode: '0000001',
        warehouseName: '总仓库',
        deviceType: '6口设备',
        supplier: '深圳供应商',
        inTime: '2020-23-23 14:23:00',
        goods: '是',
        operation: '操作'
      }],
      dialogVisible: false
    }
  }

}
</script>

<style scoped>
.myWarehouseList {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.select table {
  width: 60%;
  height: 11%;
}

.select .el-input {
  width: 25%;
}

.data {
  width: 100%;
  height: 90%;
  margin-top: 10px;
  padding: 10px;
}

.data .el-table {
  width: 100%;
  height: 90%;
}

.dialog table tr td {
  width: 50%;
}

.dialog .el-input {
  width: 77%;
}

.dialog .el-select {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/pages/warehouse/mywarehouse/warehouselist.vue